module.exports = __webpack_public_path__ + "img/users-sm.c39ed358.svg";